import { post } from '../../utils/myFetch';

export async function getOpenfireUser(params) {
  return post(`/middlecenter/service/apigateway/xmpp/op/getOpenfireUser`, params);
}
